import React, { Component } from 'react'
import { buildPath } from '../utils/route_utils.js'
import { trackEvent } from '../utils/analytics.js'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

import '../css/Footer.css';

class Footer extends Component {
    constructor(props) {
        super(props)

        this.navigate = this.navigate.bind(this)
        this.openInNewTab = this.openInNewTab.bind(this)
    }

    navigate(route) {
        if (this.props.navigate) {
            this.props.navigate(route);
        } else {
            window.location.href = buildPath(this.props.lang, route);
        }
    }

    openInNewTab(url) {
        var win = window.open(url, '_blank');
        if (win != null) {
            win.focus();
        }
    }

    render() {
        const lang = this.props.lang;
        const content = [
            {
                "title": { "en": "Products", "zh": "產品", "ja": "製品" },
                "content": {
                    "en": ["Autonomous Inspection Quadruped", "Intelligent Welding Robot", "AI Parking Management", "AI Video Security"],
                    "zh": ["自主巡檢機器狗", "智慧焊接機器人", "AI 智慧停車管理", "AI 智慧影像保全"],
                    "ja": ["自律巡回四足ロボット", "スマート溶接ロボット", "AI 駐車管理", "AI 映像セキュリティ"]
                },
                "targets": [
                    { route: '/tech/odo' },
                    { route: '/tech/beaver' },
                    { route: '/tech/pms100' },
                    { route: '/tech/vs100' }
                ]
            },
            {
                "title": { "en": "About Us", "zh": "關於我們", "ja": "会社について" },
                "content": {
                    "en": ["Home", "About Nexuni", "Core Technology", "How to Collaborate?", "Careers"],
                    "zh": ["首頁", "關於 Nexuni", "核心技術", "合作流程", "人才招募"],
                    "ja": ["ホーム", "Nexuni について", "コア技術", "協業プロセス", "採用情報"]
                },
                "targets": [
                    { route: '/' },
                    { route: '/about/about_us' },
                    { route: '/core-technology' },
                    { route: '/about/colab_flow' },
                    { route: '/about/career' }
                ]
            },
            {
                "title": { "en": "Media", "zh": "媒體影音", "ja": "メディア" },
                "content": {
                    "en": ["News", "YouTube", "Blog"],
                    "zh": ["最新消息", "YouTube", "部落格"],
                    "ja": ["ニュース", "YouTube", "ブログ"]
                },
                "targets": [
                    { route: '/about/news' },
                    { url: 'https://www.youtube.com/@nexuni' },
                    { route: '/blog' }
                ]
            },
            {
                "title": { "en": "Contact Us", "zh": "聯繫我們", "ja": "お問い合わせ" },
                "content": {
                    "en": ["Instagram", "LinkedIn", "Facebook", "Contact us"],
                    "zh": ["Instagram", "LinkedIn", "Facebook", "聯絡我們"],
                    "ja": ["Instagram", "LinkedIn", "Facebook", "お問い合わせ"]
                },
                "targets": [
                    { url: 'https://www.instagram.com/nexuni.co/' },
                    { url: 'https://www.linkedin.com/company/nexuni' },
                    { url: 'https://www.facebook.com/profile.php?id=100070603490643' },
                    { route: '/contact' }
                ]
            }
        ];

        const socialLinks = [
            { name: "LinkedIn", icon: <LinkedInIcon />, url: "https://www.linkedin.com/company/nexuni" },
            { name: "YouTube", icon: <YouTubeIcon />, url: "https://www.youtube.com/@nexuni" },
            { name: "Facebook", icon: <FacebookIcon />, url: "https://www.facebook.com/profile.php?id=100070603490643" },
            { name: "Instagram", icon: <InstagramIcon />, url: "https://www.instagram.com/nexuni.co/" }
        ];

        const currentYear = new Date().getFullYear();

        return (
            <footer className={"v2_footer_section" + (lang ? " " + lang : "")} role="contentinfo">
                <div className="v2_footer_main">
                    <div className="v2_footer_top">
                        <div className="v2_footer_logo_area">
                            <a href={buildPath(lang, '/')} className="v2_footer_logo_link" onClick={(e) => { e.preventDefault(); this.navigate('/'); }}>
                                <img src="/assets/mainpage_nexuni_white.png" alt="Nexuni" className="v2_footer_logo" />
                            </a>
                            <div className="v2_footer_social_icons">
                                {socialLinks.map((link, idx) => (
                                    <a key={idx} className="v2_footer_social_btn" href={link.url} target="_blank" rel="noopener noreferrer"
                                       aria-label={link.name}
                                       onClick={() => { trackEvent('footer_social', { url: link.url }); }}>
                                        {link.icon}
                                    </a>
                                ))}
                            </div>
                            <img
                                src="/image/nvidia_inception_dark.png"
                                alt="NVIDIA Inception Program member"
                                className="v2_footer_inception"
                                width="560"
                                height="208"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <div className="v2_footer_btn_section">
                        {content.map((item, index) => (
                            <div key={index} className="v2_footer_btn_list">
                                <h4>{item["title"][lang]}</h4>
                                {item["targets"].map((t, i) => {
                                    const label = item["content"][lang][i];
                                    const isExternal = !!t.url;
                                    const href = isExternal ? t.url : buildPath(lang, t.route);
                                    return (
                                        <a key={i} href={href}
                                           {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                           onClick={(e) => {
                                               e.preventDefault();
                                               trackEvent('footer_link', { link_text: label, location: 'footer' });
                                               if (isExternal) this.openInNewTab(t.url);
                                               else this.navigate(t.route);
                                           }}>
                                            <span>{label}</span>
                                        </a>
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="v2_copyright_section">
                    <div className="v2_copyright">&copy;{currentYear} - <strong>Nexuni Co Ltd. All rights reserved.</strong></div>
                    <div className="v2_footer_legal_links">
                        <a className="v2_security_policy_btn" href={buildPath(lang, '/about/security_policy')} onClick={(e) => { e.preventDefault(); this.navigate('/about/security_policy'); }}>
                            <span>{lang === 'en' && "Information Security Policy"}
                            {lang === 'zh' && "資訊安全政策"}
                            {lang === 'ja' && "情報セキュリティ方針"}</span>
                        </a>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
